import service from '@/utils/server';

const modName='/order/assign/';
//查询方法
export const pageInfo = data => {
  console.log('pageInfo', '-----');
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};
//初始化页面对象
export const initPage = data => {
  return service({
    url: modName + 'initPage',
    method: 'post',
    data
  });
};

//新增方法
export const saveData = data => {
  return service({
    url: modName + 'batchAdd',
    method: 'post',
    data
  });
};
//修改方法
export const editData = data => {
  return service({
    url: modName + 'update',
    method: 'post',
    data
  });
};

//查询所有运输商
export const carrierList = data => {
  return service({
    url:'/md/carrier/list',
    method: 'post',
    data
  });
};


//分配承运商提交
export const addCarrier = data => {
  return service({
    url: modName + 'distributionList',
    method: 'post',
    data
  });
};

//导出excel
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};

//基本信息
export const orderBasicDetailsInfo = data => {
  return service({
    url: modName + 'orderBasicDetailsInfo',
    method: 'post',
    data
  })
};


export const selfPickupOrder = data => {
  return service({
    url: modName + 'selfPickupOrder',
    method: 'post',
    data
  })
};



// WEBPACK FOOTER //
// ./src/page/order/assign/api/index.js